export default "__VITE_ASSET__DbhoJZ$P__"